import React from "react";

type DropdownIconProps = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
};

const DropdownIcon: React.FC<DropdownIconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "#59566C", 
  stroke = fill, 
  strokeWidth = 0.5 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64645 6.31307C3.84171 6.11781 4.15829 6.11781 4.35355 6.31307L8 9.95952L11.6464 6.31307C11.8417 6.11781 12.1583 6.11781 12.3536 6.31307C12.5488 6.50833 12.5488 6.82492 12.3536 7.02018L8.35355 11.0202C8.15829 11.2154 7.84171 11.2154 7.64645 11.0202L3.64645 7.02018C3.45118 6.82492 3.45118 6.50833 3.64645 6.31307Z"
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default DropdownIcon;
